import styles from './index.module.sass';
import { useEffect, useRef, useState } from 'react';
import Sparkles from './sparkles';
import classnames from 'classnames/bind';
import dayjs from 'dayjs';
import { CSSTransition } from 'react-transition-group';
import './success-animation.sass';
import Lottie from 'react-lottie';
import successMochi from 'json/mochi-check.json';
import Button from 'components/button';

const cx = classnames.bind(styles);

const SuccessPayment = ({ name, amount, discount, button = null, shouldLeaveBefore }) => {
  const LottieRef = useRef('');
  const [lottieShow, setLottieShow] = useState(false);

  useEffect(() => {
    const LottiePlay = setTimeout(() => {
      setLottieShow(true);
      LottieRef.current.play();
    }, 900);

    return () => {
      clearTimeout(LottiePlay);
    };
  }, []);

  const lottieClass = cx({
    lottie: true,
    show: lottieShow,
  });

  const ShouldLeaveBefore = () => {
    if (!shouldLeaveBefore) return '';
    return <div className={styles.leave}>請於 {dayjs(shouldLeaveBefore).format('HH:mm')} 前取車離場</div>;
  };

  const Discount = () => {
    if (!discount) return '';
    return <div className={styles.discount}>（折扣金額 -${Math.round(Math.abs(discount))}）</div>;
  };

  const CheckButton = () => {
    if (!button) return '';

    return (
      <Button onClick={button.onClick} style={{ margin: '15px auto 0' }}>
        {button.text}
      </Button>
    );
  };

  return (
    <div className={styles.success}>
      <Sparkles />
      <CSSTransition appear={true} in={true} timeout={700} classNames="success">
        <div className={styles.card}>
          <CSSTransition appear={true} in={true} timeout={1000} classNames="lottie">
            <div className={lottieClass}>
              <Lottie
                ref={LottieRef}
                options={{
                  loop: false,
                  animationData: successMochi,
                }}
              />
            </div>
          </CSSTransition>
          <div className={styles.name}>{name}</div>
          <div className={styles.title}>付款完成</div>
          <div className={styles.amount}>${Math.round(amount)}</div>
          <Discount />
          <ShouldLeaveBefore />
          <CheckButton />
        </div>
      </CSSTransition>
    </div>
  );
};

export default SuccessPayment;
